module.exports = __webpack_public_path__ + "static/media/Inter-Black.ef792c3c.woff";